import { Button, Flex, Text, VStack } from '@chakra-ui/react'
import { FC } from 'react'

/**
 * Màn overlay khi refresh token timeout.
 * Giữ nguyên URL, người dùng reload sẽ thử lại trên cùng trang.
 */
export const RefreshTimeoutOverlay: FC = () => {
  return (
    <Flex
      alignItems="center"
      bg="white"
      height="100vh"
      justifyContent="center"
      left={0}
      position="fixed"
      top={0}
      width="100%"
      zIndex={9999}
    >
      <VStack gap="24px" maxW="400px" px="24px" textAlign="center">
        <Text color="black.800" fontSize="16px" lineHeight="1.6">
          処理に時間がかかっています。
          <br />
          しばらくしてから、再度お試しください。
        </Text>
        <Button
          colorScheme="blue"
          size="md"
          onClick={() => window.location.reload()}
        >
          再読み込み
        </Button>
      </VStack>
    </Flex>
  )
}
